<template>
  <!-- <v-container class="d-flex justify-center mt-5">
    <v-card max-width="400" class="elevation-8 rounded-xl border-light-gray">
      <v-card-title class="text-h5 text-center font-weight-bold accent--text">
        Student ID Card
      </v-card-title>

      <v-card-text>
        <v-carousel hide-delimiters show-arrows v-model="currentIndex" class="carousel-container">
          <v-carousel-item v-for="(student, index) in students" :key="index">
            <v-card-subtitle class="text-center">
              <v-avatar size="120" class="mx-auto">
                <img :src="student.image || 'https://via.placeholder.com/120'" alt="Student Photo"
                  class="avatar-image" />
              </v-avatar>
            </v-card-subtitle>


            <v-list dense class="info-list">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Name:</strong>
                    {{ student.name || "N/A" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Roll No:</strong>
                    {{ student.rollNo || "N/A" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Date of Birth:</strong>
                    {{ student.dob || "N/A" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Parent Name:</strong>
                    {{ student.parentName || "N/A" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Contact:</strong>
                    {{ student.contact || "N/A" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Address:</strong>
                    {{ student.address || "N/A" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>


      <v-card-actions class="d-flex justify-between">
        <v-btn text color="teal" @click="onEdit" class="btn-action">
          <v-icon left>mdi-pencil</v-icon>Edit
        </v-btn>
        <v-btn text color="navy" @click="onUpdate" class="btn-action">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container> -->
<v-contaier>
  hii
  {{ student }}
</v-contaier>
</template>

<script setup>
import { computed, ref, watch, onMounted } from "vue";
import { useStudentStore } from "@/Store/StudentStore";
import { useRouter, useRoute } from 'vue-router';
import { studentDetail } from "@/services/apiServices";

// const studentStore = useStudentStore();
// const studentId = computed(() => studentStore.currentStudentId);

// console.log("Current Student ID:", studentId.value);

// Router and Store setup
const route = useRoute();

// Access className from the route parameters
const StudentIdFromRoute = route.params.studentId;
const classIdFromRoute = route.params.classId;

// console.log("StudentIdFromRoute:", StudentIdFromRoute);
// console.log("classIdFromRoute:", classIdFromRoute);

const student = ref(null);
const currentIndex = ref(null); // Declare currentIndex as a ref

const fetchStudent = async () => {
  try {
    const data = await studentDetail(StudentIdFromRoute, classIdFromRoute ); 
    // console.log("school", data);
    student.value = data; 
  } catch (err) {
    console.error("Error fetching school details:", err);
  }
};

onMounted(fetchStudent); 

// Watch for changes in selected student index
watch(
  () => studentStore.selectedStudentIndex,
  (newIndex) => {
    currentIndex.value = newIndex; // Update carousel when index changes
  }
);



// Edit and Update handlers
const onEdit = () => {
  studentStore.updateStudent(student.value);
};

const onUpdate = () => {
  studentStore.updateStudent(student.value);
};
</script>

<style scoped>
.v-card {
  background-color: #f4f4f4;
  border-radius: 20px;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.v-avatar {
  width: 120px;
  height: 120px;
  margin-bottom: 10px;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  image-rendering: auto;
}

.v-card-title {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #263238;
  padding-top: 20px;
  padding-bottom: 15px;
}

.info-list {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
}

.v-card-actions {
  background-color: #fafafa;
  padding: 10px;
}

.btn-action {
  font-weight: 500;
  border-radius: 20px;
}

.v-btn {
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.carousel-container .v-carousel-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-btn--icon {
  top: -193px;
}

@media (max-width: 768px) {
  .v-card {
    max-width: 100%;
  }

  .v-avatar {
    size: 90px;
  }

  .v-card-title {
    font-size: 1.5rem;
  }
}
</style>
